import React, { useState } from 'react';

import { Drivers } from '../../Drivers/Drivers';
import { FleetSafetyTab } from '../../components';

import './DriversView.scss';

export function DriversView() {
  const [activeTab, setActiveTab] = useState<'roster' | 'safety'>('roster');

  const tabs: Array<{ id: 'roster' | 'safety'; label: string }> = [
    { id: 'roster', label: 'Roster' },
    { id: 'safety', label: 'Safety' },
  ];

  return (
    <div className='drivers-view-component'>
      <div className='header'>
        <h1>Driver Management</h1>
      </div>

      <div className='nav-tabs'>
        {tabs.map(tab => (
          <div
            key={tab.id}
            className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </div>
        ))}
      </div>

      <div className='container'>
        {activeTab === 'roster' ? <Drivers /> : <FleetSafetyTab />}
      </div>
    </div>
  );
}
